module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_5010.b068989b.png";